export default "__VITE_ASSET__CdYYUtFh__"